import 'css-chunksrc/client/pages/projectPage/documentsPage/sideBar/directoryStructure/styles.scss';export default {
  "header": "_header_1lf8o_1",
  "name": "_name_1lf8o_10",
  "toggleIconBox": "_toggleIconBox_1lf8o_14",
  "toggleIcon": "_toggleIcon_1lf8o_14",
  "icon": "_icon_1lf8o_24",
  "children": "_children_1lf8o_36",
  "root": "_root_1lf8o_40",
  "open": "_open_1lf8o_45",
  "selected": "_selected_1lf8o_49",
  "dropZone": "_dropZone_1lf8o_69"
};